import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import AnimatedText from "../AnimatedText";

const HeroSection: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { minutes: prev.minutes - 1, seconds: 59 };
        } else {
          return { minutes: 0, seconds: 0 };
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative bg-white py-8 md:py-16 overflow-hidden">
      {/* Floating Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          animate={{ 
            y: [0, -20, 0],
            rotate: [0, 5, 0]
          }}
          transition={{ 
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="absolute top-20 left-10 w-20 h-20 bg-red-500/10 rounded-full blur-xl"
        />
        <motion.div
          animate={{ 
            y: [0, 20, 0],
            rotate: [0, -5, 0]
          }}
          transition={{ 
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2
          }}
          className="absolute top-40 right-20 w-32 h-32 bg-red-600/5 rounded-full blur-2xl"
        />
        <motion.div
          animate={{ 
            y: [0, -15, 0],
            x: [0, 10, 0]
          }}
          transition={{ 
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 4
          }}
          className="absolute bottom-20 left-1/4 w-16 h-16 bg-red-400/10 rounded-full blur-lg"
        />
      </div>
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center">
          {/* Red Banner */}
              <motion.div
                initial={{ opacity: 0, y: -30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                whileHover={{ scale: 1.05 }}
                className="bg-red-600 text-white px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-sm sm:text-lg font-bold inline-block mb-6 sm:mb-8 relative z-20 w-full max-w-xs sm:max-w-md"
              >
            <div className="text-sm sm:text-xl font-black uppercase">3 HOUR ONLINE WEBINAR</div>
            <div className="text-xs sm:text-lg font-bold uppercase">STARTS ON October 30th</div>
            <div className="text-xs sm:text-sm font-semibold">(1:00 PM  IST)</div>
          </motion.div>

          {/* Main Content Panel */}
            <motion.div
              initial={{ opacity: 0, y: 30, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3, type: "spring", stiffness: 100 }}
              whileHover={{ scale: 1.02, boxShadow: "0 0 40px rgba(255, 255, 255, 0.1)" }}
              className="max-w-5xl mx-auto rounded-2xl p-4 sm:p-6 md:p-8 border-2 border-red-500 relative -mt-8 sm:-mt-12 md:-mt-16 bg-white"
            >
            <AnimatedText
              text="Double Your Salon's Growth: Leads, Retention & Revenue"
              className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black leading-tight text-black mb-4 sm:mb-6"
              type="fade"
            />

          

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="text-m text-black mb-4"
            >
              Designed for Salon, Spa & Nail Studio Owners/Managers
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.0 }}
              className="text-m text-black mb-4"
            >
              Backed by Zylu Experts – trusted by 1,000+ salon and spa businesses across the world!
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.2 }}
              className="text-m text-black "
            >
              Learn proven strategies to generate unlimited leads, retain more clients, manage staff efficiently & double revenue
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
